import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CompoundFilter from './CompoundFilter.js';
import SimpleFilter from './SimpleFilter.js';
import { SIMPLE, COMPOUND } from '../../../static/keyWords.js';
import ExpansionPanel from '../ExpansionPanel/ExpansionPanel.js';
import { getChipCount } from './filterHelpers.js';

const Filters = ({
  settings,
  appliedFilters,
  innerAppliedFilters,
  setInnerAppliedFilters,
  filterLabelsParams,
  isLinked,
  setIsLinked,
  setRefresh,
}) => {
  const [simpleFilters, setSimpleFilters] = useState([]);
  const [compoundFilters, setCompoundFilters] = useState([]);

  const chipCount = getChipCount(simpleFilters, appliedFilters, 'type', 'type');
  const simpleFilterTypes = (simpleFilters || []).map(filter => filter.type);

  useEffect(() => {
    if (settings && settings.length) {
      setSimpleFilters(
        settings.filter((setting) => setting.filterType === SIMPLE)
      );
      setCompoundFilters(
        settings.filter((setting) => setting.filterType === COMPOUND)
      );
    }
  }, [settings]);

  return (
    <div className="filters-container">
      {simpleFilters.length ?
        <ExpansionPanel
          titleClasses="filter-expansion-panel-title forge-typography--heading2"
          iconClasses="filter-expansion-panel-icon-container"
          title="General"
          withCard={false}
          chipCount={chipCount}
          clearButton={chipCount > 0}
          handleClearButton={(e) => {
            e.stopPropagation();
            setInnerAppliedFilters(state => state.filter(filter => !simpleFilterTypes.includes(filter.type)));
            setRefresh({});
          }}
        >
          {simpleFilters.map((setting, index) => (
            <SimpleFilter
              key={`${setting.type}_${index}`}
              setting={setting}
              innerAppliedFilters={innerAppliedFilters}
              setInnerAppliedFilters={setInnerAppliedFilters}
              filterLabelsParams={filterLabelsParams}
              isLinked={isLinked}
              setIsLinked={setIsLinked}
            />
          ))}
        </ExpansionPanel>
        : null }
      {compoundFilters.length ? compoundFilters.map((setting, index) => (
        <CompoundFilter
          key={`${setting.type}_${index}`}
          setting={setting}
          appliedFilters={appliedFilters}
          innerAppliedFilters={innerAppliedFilters}
          setInnerAppliedFilters={setInnerAppliedFilters}
          filterLabelsParams={filterLabelsParams}
          isLinked={isLinked}
          setIsLinked={setIsLinked}
          setRefresh={setRefresh}
          index={index}
        />
      ))
      : null}
    </div>
  );
};

Filters.propTypes = {
  settings: PropTypes.array,
  appliedFilters: PropTypes.array,
  innerAppliedFilters: PropTypes.array,
  setInnerAppliedFilters: PropTypes.func,
  filterLabelsParams: PropTypes.object,
  isLinked: PropTypes.bool,
  setIsLinked: PropTypes.func,
  setRefresh: PropTypes.func,
};

export default Filters;
